/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "EDIT" | "REJECT" | "%future added value";
export type ReplyListContainerLastFlattened_comment = {
    readonly id: string;
    readonly status: COMMENT_STATUS;
    readonly pending: boolean | null;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly replies: {
        readonly viewNewEdges: ReadonlyArray<{
            readonly cursor: unknown;
            readonly node: {
                readonly id: string;
                readonly enteredLive: boolean | null;
                readonly replyCount: number;
                readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
            };
        }> | null;
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly enteredLive: boolean | null;
                readonly replyCount: number;
                readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
            };
            readonly __typename: string;
        }>;
    };
    readonly " $refType": "ReplyListContainerLastFlattened_comment";
};
export type ReplyListContainerLastFlattened_comment$data = ReplyListContainerLastFlattened_comment;
export type ReplyListContainerLastFlattened_comment$key = {
    readonly " $data"?: ReplyListContainerLastFlattened_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLastFlattened_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v3 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "CommentContainer_comment"
    } as any), v4 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "IgnoredTombstoneOrHideContainer_comment"
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 10,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "flattenReplies"
            },
            {
                "defaultValue": "CREATED_AT_ASC",
                "kind": "LocalArgument",
                "name": "orderBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "replies"
                    ]
                }
            ]
        },
        "name": "ReplyListContainerLastFlattened_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
            },
            {
                "alias": "replies",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    }
                ],
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__ReplyList_replies_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v1 /*: any*/),
                                    (v2 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/),
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            (v5 /*: any*/)
                                        ]
                                    }
                                ],
                                "storageKey": null
                            },
                            (v2 /*: any*/),
                            (v6 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "viewNewEdges",
                                "plural": true,
                                "selections": [
                                    (v6 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v5 /*: any*/),
                                            (v1 /*: any*/),
                                            (v3 /*: any*/),
                                            (v4 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ]
                    }
                ],
                "storageKey": null
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pending",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastViewerAction",
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'be0cc8dbde7b236db0dd8ee6f7d320e1';
export default node;
